import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { RecoilRoot } from "recoil";
import reportWebVitals from './reportWebVitals';
import AfterEffect from './components/AfterEffect';
import './index.css';
import "./assets/js/i18n.js";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RecoilRoot>
    <BrowserRouter>
      <AfterEffect />
      <App />
    </BrowserRouter>
  </RecoilRoot>
);

reportWebVitals();